import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'cp-account-classes',
    templateUrl: './account-classes.component.html',
    styleUrls: ['./account-classes.component.scss'],
    standalone: false
})
export class AccountClassesComponent {

  constructor() { }

}
